import { http } from '@/lib/http';
import { http as atsHttp } from '@/lib/ats-https';
import { SEARCH_RESULTS_PER_PAGE } from './constant';

const getContactDeails = async ({
  searchTerm,
  includeResume = false,
  signal,
}: {
  searchTerm: string;
  includeResume: boolean;
  signal: AbortSignal;
}) => {
  const response = await http.post(
    `/search/circles/contacts`,
    {
      extended_fields: true,
      limit: SEARCH_RESULTS_PER_PAGE,
      name: includeResume ? undefined : searchTerm,
      offset: 0,
      // sort_element: 'tst',
      // sort_order: 'desc',
      resume_text: includeResume ? searchTerm : undefined,
    },
    { signal }
  );
  return response?.data;
};

const getJobDetails = async ({
  searchTerm,
  signal,
}: {
  searchTerm: string;
  signal: AbortSignal;
}) => {
  const response = await atsHttp.get(`/ats_jobs`, {
    params: {
      view: 'card',
      limit: SEARCH_RESULTS_PER_PAGE,
      q: searchTerm,
      sort_by: { created_at: 'desc' },
    },
    signal,
  });
  return response?.data;
};

const getFlowDetails = async ({
  searchTerm,
  signal,
}: {
  searchTerm: string;
  signal: AbortSignal;
}) => {
  const response = await http.get(`/search/outreaches`, {
    params: {
      q: searchTerm,
    },
    signal,
  });
  return response?.data;
};

const getInterviewDetails = async ({
  searchTerm,
  signal,
}: {
  searchTerm: string;
  signal: AbortSignal;
}) => {
  const response = await atsHttp.get(`/ats_interviews`, {
    params: {
      filter_by: { name: searchTerm },
      items: SEARCH_RESULTS_PER_PAGE,
      sort_by: { created_at: 'desc' },
      page: 1,
    },
    signal,
  });
  return response?.data;
};

export { getContactDeails, getJobDetails, getFlowDetails, getInterviewDetails };
